import React from 'react';
import classnames from 'classnames';
import {useBreakpoints} from "@nutastic/nutastic-react-app";

const LinksNavBar = ({ activePage, onClick, pages = [] }) => {
    const { md: shouldFadeNav } = useBreakpoints();
    const classes = classnames('animated', 'delay-1s', 'fadeInDown');

    const navItemsRender = pages.map((page, pageIndex) => {
        const { navText } = page;
        const navClasses = classnames({
            active: activePage === pageIndex}
        );
        const onNavClick = () => onClick(pageIndex);
        return <span className={navClasses} onClick={onNavClick}>{navText}</span>;
    });

    return <div id="linksAppNavigation" className={classes}>
        { navItemsRender }
    </div>;
};

export default LinksNavBar;
